import type { Goals, GoalWithIds } from '../../types';

export const splitGoals = (
	goals: Goals,
): {
	defaultGoals: GoalWithIds;
	draggableGoals: GoalWithIds;
} =>
	Object.keys(goals).reduce(
		(goalList, goalKey) => {
			const goal = goals[goalKey];
			if (goal.defaultGoal) {
				// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
				goalList.defaultGoals.push({ id: goalKey, ...goal });
			} else {
				// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
				goalList.draggableGoals.push({ id: goalKey, ...goal });
			}
			return goalList;
		},
		{ defaultGoals: [], draggableGoals: [] },
	);
